<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{on}">
      <slot name="activator" v-bind:on="{click: ()=> dialog=true}">
        <v-btn block color="primary">
          Podpisz
        </v-btn>
      </slot>
    </template>

    <v-sheet style="padding: 1rem">
      <v-list v-if="stage == 1">
        <v-list-tile v-for="field in schema.fields.filter(el => el.type == FieldType.SIGNATURE)" style="cursor: pointer"
                     @click="selectField(field)">
          {{ field.name }}
        </v-list-tile>
      </v-list>

      <div v-if="stage == 2">
        <h5>Grupowe podpisywanie pola: {{ selectedField.name }}</h5>

        <div style="margin-top: 1rem;max-height:500px;overflow-y:auto">
          <div v-for="{result, idForm, color} in selectedRecords">
            <span>Formularz ID {{ idForm }} : </span>
            <span :style="`color: ${color}`">{{ result }}</span>
          </div>
        </div>

        <Signature :context="Context.createFormContextWithFields(schema.fields)" :field="selectedField"
                   @setValue="setValue"></Signature>
        <v-btn :disabled="selectedRecords.find(el => el.result != 'OK')" color="primary" @click="submit()">Zapisz
        </v-btn>

        <div v-if="loading">
          Trwa aktualizacja...
          <v-progress-linear indeterminate></v-progress-linear>
        </div>

      </div>

    </v-sheet>
  </v-dialog>
</template>

<script>
import FieldType from "../../enums/fieldType"
import Signature from "./inputs/Signature.vue"
import Context from "../../plugins/Context"
import ImageHelper from "../../helpers/ImageHelper"
import Messenger from "../../plugins/Messenger"

export default {
  components: {Signature},
  computed: {
    Context() {
      return Context
    },
    FieldType() {
      return FieldType
    },
    selectedRecords() {
      return this.selectedFormRecords
    }
  },
  props: ['records', 'schema', 'selected'],
  data() {
    return {
      stage: 1,
      selectedField: {},
      selectedFormRecords: [],
      dialog: false,
      signValue: null,
      loading: false
    }
  },
  methods: {
    submit() {
      if (!this.signValue) {
        return
      }

      let requests = []
      this.loading = true
      this.selectedFormRecords.filter(el => el.result == "OK").forEach(selectedForm => {
        let putReq = this.$http.put('form/' + this.$route.params.schemaId + "/" + selectedForm.idForm, {
          results: [
            {order: this.selectedField.order, value: this.signValue}
          ]
        })

        requests.push(putReq)
      })

      Promise.all(requests).then(() => {
        this.$emit('refresh')
        this.dialog = false
        this.loading = false
      }).catch(() => {
        Messenger.emitError("Wystapił bład podczas aktualizacji co najmniej jednego formularza!")
      })
    },
    setValue(value) {
      this.signValue = value
    },
    getSelectedFormRecords() {
      this.selectedFormRecords = []

      for (let idForm in this.selected) {
        if (this.selected[idForm]) {
          let record = this.records.find(el => el.id == idForm)

          if (!record) {
            this.selectedFormRecords.push({idForm, result: "ERROR", color: "red"})
            // Vue.set(this.selectedFormRecords, idForm, "ERROR")
            continue
          }

          if (record[this.selectedField.order] == null || record[this.selectedField.order].data == null) {
            this.selectedFormRecords.push({idForm, result: "OK", color: "green"})
            continue

          }

          ImageHelper.createImage(record[this.selectedField.order].data).then(image => {
            let imgData = ImageHelper.getCanvasImageData(image)
            if (ImageHelper.checkColorIsHomogeneous(imgData, false)) {
              this.selectedFormRecords.push({idForm, result: "OK", color: "green"})
            } else {
              this.selectedFormRecords.push({idForm, result: "Uwaga! Podpis już istnieje!", color: "red"})
            }
          })
        }
      }
    },
    selectField(field) {
      this.selectedField = field
      this.getSelectedFormRecords()
      this.stage = 2
    }
  },
  watch: {
    dialog: function (newVal) {
      if (!newVal) {
        this.stage = 1
      }
    }
  }
}

</script>

<style scoped>

</style>